/** DejaUp → Portal BLINK filter handoff (hash fragment + optional postMessage). */
export const BLINK_HANDOFF_READY = 'IPP_BLINK_HANDOFF_READY';
export const BLINK_FILTER_HANDOFF = 'IPP_BLINK_FILTER_HANDOFF';
export const BLINK_HANDOFF_SOURCE = 'dejaup';
export const BLINK_HANDOFF_HASH_KEY = 'ippBlinkHandoff';

export interface BlinkFilterHandoffFilters {
  posConditionCode?: string[];
  merchantIds?: string[];
  transactionId?: string;
  rrn?: string;
}

export interface BlinkFilterHandoffMessage {
  type: typeof BLINK_FILTER_HANDOFF;
  source: typeof BLINK_HANDOFF_SOURCE;
  autoSearch: boolean;
  filters: BlinkFilterHandoffFilters;
  ts?: number;
}

export interface BlinkHandoffReadyMessage {
  type: typeof BLINK_HANDOFF_READY;
  ts: number;
}

/** Hash / postMessage stash on Portal origin (sessionStorage). */
export const BLINK_HANDOFF_SESSION_KEY = 'ipp_blink_filter_handoff';

/** Parsed pending handoff from hash or sessionStorage. */
export interface BlinkPendingHandoff {
  filters: BlinkFilterHandoffFilters;
  autoSearch: boolean;
}
